import React from 'react';

import Head from 'next/head';

const GeneralCard = ({ slice }) => {
  const data = slice.primary;

  return (
    <Head>
      {data['title'] && <title>{data['title']}</title>}
      {data['description'] && (
        <meta
          key="description"
          content={data['description']}
          name="description"
        />
      )}
      {data['canonical'] && (
        <link key="canonical" href={data['canonical']} rel="canonical" />
      )}
    </Head>
  );
};

export default GeneralCard;
